import React from 'react';

import Select from 'react-select';
import Rating from 'react-rating';

import Chart from "../../components/brews/Chart";
import Notes from "../../components/notes/Notes";
import FlavourColumn from "../../components/brews/FlavourColumn";

import tasteList from "../../static/tasteList.json";
import typeList from "../../static/typeList.json";
import varietalList from "../../static/varietalList.json";
import processList from "../../static/processList.json";
import roastList from "../../static/roastList.json";

import StarBorder from '../../images/icons/star-outline.svg';
import StarFill from '../../images/icons/star-fill.svg';

import GlobalData from '../../context/globaldata';

const customFormSelect = {
  option: (provided, state) => ({
    ...provided
  }),
  input: (styles, { data }) => {
    return {
      ...styles,
      margin: 0
    }
  },
  placeholder: (styles, { data }) => {
    return {
      ...styles,
      fontSize: 17
    }
  }
};

class Form extends React.Component {
  static contextType = GlobalData;

  constructor(props) {
    super(props);

    this.state = {
      hideUnused: false,
      actionsVisible: false
    };
  };

  toggleHideUnused = () => {
    this.setState({
      hideUnused: !this.state.hideUnused
    });
  };

  brewRatio = () => {
    return `${ this.props.brew.dose && this.props.brew.yield ? Math.round(this.props.brew.yield / this.props.brew.dose * 100) / 100 : '0' }`;
  };

  filterRatio = () => {
    return `${ this.props.brew.dose && this.props.brew.yield ? Math.round(1000 / this.props.brew.yield) * this.props.brew.dose : '0' }`;
  };

  toggleNotes = (event) => {
    if(event) {
      event.preventDefault();
    }

    this.setState({
      notesVisible: !this.state.notesVisible
    });
  };

  toggleActions = (event) => {
    if(event) {
      event.preventDefault();
    }

    this.setState({
      actionsVisible: !this.state.actionsVisible,
      notesVisible: false
    });
  };

  render() {
    return (
      <form className="brew__form" onSubmit={ this.props.submitForm }>
        <div className="brew__container form">
          <div className="form__section">
            <div className="form__block">
              <div className="form__column form__column--small">
                <label className="form__label">
                  <span>Name</span>
                  <input className="form__input" name="name" type="text" value={ this.props.brew.name } onChange={ this.props.handleChange } disabled={(this.props.readOnlyMode) && "disabled"} required />
                </label>
              </div>
              <div className="form__column form__column--small">
                <label className="form__label">
                  <span>Roaster</span>
                  <input className="form__input" name="roaster" type="text" value={ this.props.brew.roaster } onChange={ this.props.handleChange } disabled={(this.props.readOnlyMode) && "disabled"} />
                </label>
              </div>
              <div className="form__column form__column--small">
                <label className="form__label">
                  <span>Rating</span>
                  <Rating className="form__rating" initialRating={ this.props.brew.rating } fractions="2" emptySymbol={ <img src={ StarBorder } className="favorite-icon" alt="" /> } fullSymbol={ <img src={ StarFill } className="favorite-icon" alt="" /> } onChange={ this.props.updateRating } readonly={(this.props.readOnlyMode) ? true : false} />
                </label>
              </div>
              <div className="form__column form__column--small">
                <label className="form__label">
                  <span>Origin</span>
                  <input className="form__input" name="origin" type="text" value={ this.props.brew.origin } onChange={ this.props.handleChange } disabled={(this.props.readOnlyMode) && "disabled"} />
                </label>
              </div>
              <div className="form__column form__column--small">
                <label className="form__label">
                  <span>Producer</span>
                  <input className="form__input" name="producer" type="text" value={ this.props.brew.producer } onChange={ this.props.handleChange } disabled={(this.props.readOnlyMode) && "disabled"} />
                </label>
              </div>
              <div className="form__column form__column--small">
                <label className="form__label">
                  <span>Type</span>
                  <Select name="type" className='form-select' value={this.props.brew.type} getOptionValue={ option => option.value } classNamePrefix="form-select" styles={customFormSelect} onChange={this.props.handleChange} options={typeList} isDisabled={(this.props.readOnlyMode) ? true : false} />
                </label>
              </div>
            </div>
            <div className="form__block">
              <div className="form__column form__column--large">
                <label className="form__label form__label--small">
                  <span>Varietal</span>
                  <Select name="varietal" className='form-select' value={this.props.brew.varietal} getOptionValue={ option => option.value } classNamePrefix="form-select" closeMenuOnSelect={false} styles={customFormSelect} onChange={this.props.handleChange} options={varietalList} isMulti isDisabled={(this.props.readOnlyMode) ? true : false} />
                </label>
              </div>
              <div className="form__column form__column--small">
                <label className="form__label">
                  <span>Process</span>
                  <Select name="process" className='form-select' value={this.props.brew.process} getOptionValue={ option => option.value } classNamePrefix="form-select" styles={customFormSelect} onChange={this.props.handleChange} options={processList} isDisabled={(this.props.readOnlyMode) ? true : false} />
                </label>
              </div>
              <div className="form__column form__column--small">
                <label className="form__label">
                  <span>Roast</span>
                  <Select name="roast" className='form-select' value={this.props.brew.roast} getOptionValue={ option => option.value } classNamePrefix="form-select" styles={customFormSelect} onChange={this.props.handleChange} options={roastList.default} isDisabled={(this.props.readOnlyMode) ? true : false} />
                </label>
              </div>
              <div className="form__column form__column--small">
                <label className="form__label">
                  <span>Roast date</span>
                  <input className="form__input" name="roast_date" type="date" value={this.props.brew.roast_date} onChange={this.props.handleChange} disabled={(this.props.readOnlyMode) && "disabled"} />
                </label>
              </div>
              <div className="form__column form__column--small">
                <label className="form__label">
                  <span>Opening date</span>
                  <input className="form__input" name="opening_date" type="date" value={ this.props.brew.opening_date } onChange={ this.props.handleChange } disabled={ (this.props.readOnlyMode) && "disabled" } />
                </label>
              </div>
            </div>
            <div className="form__block">
              <div className="form__column form__column--xsmall">
                <label className="form__label">
                  <span>Dose (g)</span>
                  <input className="form__input" name="dose" type="number" value={ this.props.brew.dose } onChange={ this.props.handleChange } disabled={(this.props.readOnlyMode) && "disabled"} />
                </label>
              </div>
              <div className="form__column form__column--xsmall">
                <label className="form__label">
                  <span>Ratio</span>
                  <div className="form__split">
                    <input className="form__input" value={ `${ this.brewRatio() }` } disabled />
                    { this.props.brew.type.value === 'filter' &&
                      <input className="form__input" value={ `${ this.filterRatio() } gram/L` } disabled />
                    }
                  </div>
                </label>
              </div>
              <div className="form__column form__column--xsmall">
                <label className="form__label">
                  <span>Yield (g)</span>
                  <input className="form__input" name="yield" type="number" value={ this.props.brew.yield } onChange={ this.props.handleChange } disabled={(this.props.readOnlyMode) && "disabled"} />
                </label>
              </div>
              <div className="form__column form__column--xsmall">
                <label className="form__label">
                  <span>Temperature (℃)</span>
                  <input className="form__input" name="temperature" type="number" min="1" max="100" value={ this.props.brew.temperature } onChange={ this.props.handleChange } disabled={(this.props.readOnlyMode) && "disabled"} />
                  <div className="temperature">
                    <div className="temperature__meter" style={{width: `${Math.abs(100 - this.props.brew.temperature)}%` }}></div>
                  </div>
                </label>
              </div>
              <div className="form__column form__column--xsmall">
                <label className="form__label">
                  <span>Brew time (mm:ss)</span>
                  <input className="form__input" name="time" type="text" value={ this.props.brew.time } onChange={ this.props.handleChange } disabled={(this.props.readOnlyMode) && "disabled"} />
                </label>
              </div>
              <div className="form__column form__column--xsmall">
                <label className="form__label">
                  <span>Device</span>
                  <input className="form__input" name="device" type="text" value={ this.props.brew.device } onChange={ this.props.handleChange } disabled={(this.props.readOnlyMode) && "disabled"} />
                </label>
              </div>
              <div className="form__column form__column--xsmall">
                <label className="form__label">
                  <span>Grinder</span>
                  <input className="form__input" name="grinder" type="text" value={ this.props.brew.grinder } onChange={ this.props.handleChange } disabled={(this.props.readOnlyMode) && "disabled"} />
                </label>
              </div>
              <div className="form__column form__column--xsmall">
                <label className="form__label">
                  <span>Brew date</span>
                  <input className="form__input" name="brew_date" type="date" value={ this.props.brew.brew_date } onChange={ this.props.handleChange } disabled={(this.props.readOnlyMode) && "disabled"} />
                </label>
              </div>
            </div>
          </div>
          <div className="form__section">
            <div className="form__block form__block--flavours">
              <button className="form__toggle" type="button" title="Show/hide unused flavours" onClick={ this.toggleHideUnused }>
                <i className="material-icons">{ this.state.hideUnused ? 'visibility' : 'visibility_off' }</i>
              </button>
              <Chart
                brew={ this.props.brew }
                advancedChart={ this.props.brew.advancedChart }
              />
              <FlavourColumn
                flavours={ tasteList.default }
                currentBrew={ this.props.brew }
                onChange={ this.props.handleChange }
                hideUnused={ this.state.hideUnused }
                readOnlyMode={ this.props.readOnlyMode }
              />
              { this.props.brew.advancedChart &&
                <FlavourColumn
                  flavours={ tasteList.advanced }
                  currentBrew={ this.props.brew }
                  onChange={ this.props.handleChange }
                  hideUnused={ this.state.hideUnused }
                  readOnlyMode={ this.props.readOnlyMode }
                />
              }
            </div>

            { this.context.userSettings.premium_user &&
              <button className={`flavours__toggle ${ this.props.brew.advancedChart && 'is-active' }`} type="button" onClick={ () => this.props.saveBrewState('advancedChart', !this.props.brew.advancedChart) }>
                <span>Show { this.props.brew.advancedChart ? 'less' : 'more' } flavours</span>
                <i className="material-icons">expand_more</i>
              </button>
            }

            <div className={`related-actions ${ this.state.actionsVisible ? 'is-visible' : '' }`}>
              <div className="related-actions__overlay" onClick={ this.toggleActions }></div>
              <button className="related-actions__toggle" onClick={ this.toggleActions }>
                <i className="related-actions__open material-icons">attach_file</i>
                <i className="related-actions__close material-icons">close</i>
              </button>
              <div className="related-actions__buttons">
                { this.context.userSettings.premium_user &&
                  <button className="related-actions__button" onClick={ this.toggleNotes }>
                    <i className="material-icons">add_a_photo</i>
                    <span>Add header image</span>
                  </button>
                }
                <button className="related-actions__button" onClick={ this.toggleNotes }>
                  <i className="material-icons">notes</i>
                  <span>Add notes</span>
                </button>
              </div>
            </div>

            <Notes
              currentBrew={ this.props.brewId }
              actionsVisible={ this.state.actionsVisible }
              toggleActions={ this.toggleActions }
              isVisible={ this.state.notesVisible }
              updateNotes={ this.props.updateNotes }
              content={ this.props.brew.notes }
              toggleNotes={ this.toggleNotes }
            />
          </div>
        </div>
      </form>
    )
  }
}

export default Form;
